"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _gerenciatdUnifiedcomponents = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.stopper"));

var _gerenciatdUtils = _interopRequireDefault(require("@bit/gerenciatd.utils.front-sonda"));

var _Error = _interopRequireDefault(require("./Screens/Error"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Componente statefull que crea el ErrorBoundary
 * @param {string} error Error atrapado
 * @param {string} errorInfo Detalles del error que renderiza la pagina
 * @returns {JSX} Componente JSX.
 */
class ErrorBoundary extends _react.default.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "componentDidMount", () => {
      const {
        history
      } = this.props;
      history.listen(location => {
        const {
          errorInfo
        } = this.state;

        if (errorInfo) {
          this.setState({
            redirect: location
          });
        }
      });
    });

    _defineProperty(this, "componentWillUnmount", () => {
      const {
        history
      } = this.props;

      if (history) {
        try {
          history.removeEventListener('listen');
        } catch (err) {// console.log(`err: ${err}`);
        }
      }
    });

    _defineProperty(this, "sendSondaInfo", error => {
      const {
        contextData
      } = this.state;
      const sonda = new _gerenciatdUtils.default({
        processName: 'ErrorBoundary',
        context: contextData,
        filePath: 'AppController'
      });
      sonda.fatalMessage({
        error
      });
    });

    _defineProperty(this, "componentDidCatch", error => {
      this.setState({
        errorInfo: error
      });
      this.sendSondaInfo(error);
    });

    const {
      contextData: _contextData
    } = props;
    this.state = {
      errorInfo: null,
      redirect: null,
      contextData: _contextData
    };
  }
  /**
   * Crea una subscripcion para escuchar los cambios del history
   */


  render() {
    if (this.state.redirect && this.state.errorInfo) {
      this.setState({
        redirect: null,
        errorInfo: null
      });
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Redirect, {
        to: this.state.redirect
      });
    }

    if (!this.state.errorInfo) {
      /* Normally, just render children, all APP */
      return this.props.children;
    }

    const {
      defaultErrorScreen,
      projectId
    } = this.props;

    if (defaultErrorScreen) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread(_objectSpread({}, defaultErrorScreen), {}, {
        projectId: projectId
      }));
    }

    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Error.default, {});
  }

}

var _default = ErrorBoundary;
exports.default = _default;

//# sourceMappingURL=ErrorBoundary.js.map